
import {put} from "redux-saga/effects";
import {inputError} from "./login-action-creators";

export function* validate({input, action}) {
  if (input.value === "") {
    yield put(action({error: "Should not be empty", field: input.field }));
    return false;
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/modules/login/utility.js